import axios from "axios";
import config from "@/App/config";
import { Storage as storage } from "@/App/services/LocalStorage";
import { getClientTime } from "@/Utils/getClientTime";

export const HttpEngine = axios.create({
  baseURL: config.API_URL,
  headers: {
    common: { accept: "application/json" },
  },
});

HttpEngine.interceptors.request.use(function (config) {
  const token = storage.getItem("jwt");
  if (token) {
    config.headers.Authorization = `JWT ${token}`;
  }

  config.headers["Created-At"] = getClientTime();

  return config;
});
